import React from 'react';
import styled from 'styled-components';
import { IMinicut } from 'utils/types/resourceTypes';
import { ISupportLanguage } from 'utils/types/storyTypes';
import { handleMessage } from 'utils/helper/message';
import { message } from 'antd';
import InputWrappingBox from 'components/container/InputWrappingBox';
import LanguageBox from './LanguageBox';
import AddLanguageButton from 'components/AddLanguageButton';

interface IProps {
  supportLangList: ISupportLanguage[] | null;
  data: IMinicut | null;
  setData: React.Dispatch<React.SetStateAction<IMinicut | null>>;
}
const LeftSideContent: React.FC<IProps> = ({
  supportLangList,
  data,
  setData,
}) => {
  const handleAddLanguage = () => {
    if (data) {
      if (data.localizations.length > 6) {
        handleMessage(message, 'error', 'Episode only can have 7 languages');
      } else {
        const cloneArr = [...data.localizations];
        cloneArr.push({
          id: null,
          lang: 'KO',
          resource_type: '',
          public_name: '',
          summary: '',
        });
        const cloneData = JSON.parse(JSON.stringify(data));
        cloneData['localizations'] = cloneArr;
        setData(cloneData);
      }
    }
  };
  return (
    <Wrapper>
      {!data?.is_public && <div className='disabled'></div>}
      <div className='localBox'>
        {data?.localizations?.map((el, i) => {
          return (
            <InputWrappingBox left key={i}>
              <LanguageBox
                index={i}
                langList={supportLangList}
                detailData={el}
                data={data}
                setData={setData}
              />
            </InputWrappingBox>
          );
        })}
        <AddLanguageButton handleAddLanguage={handleAddLanguage} />
      </div>
    </Wrapper>
  );
};

export default LeftSideContent;

const Wrapper = styled.div`
  position: relative;
  .localBox {
    & > * + * {
      margin-top: 24px;
    }
  }
  .disabled {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.548);
    z-index: 99;
    top: 0;
    right: 0;
  }
`;
